/** Display notes from earning / user-plan list rows */
export const getPlanNotes = (row) => {
  const n = row?.notes;
  if (n == null || String(n).trim() === "") return "";
  return String(n).trim();
};

export const formatNotesForTable = (row, maxLen = 60) => {
  const full = getPlanNotes(row);
  if (!full) return { display: "—", title: "" };
  return {
    display: full.length > maxLen ? `${full.slice(0, maxLen)}…` : full,
    title: full,
  };
};

export const formatNotesForExport = (row) => getPlanNotes(row);
